import createUrl from "../../utils/createUrl";
import { publicFetch } from "../../utils/CustomFetch";
import { URL } from "../../utils/UrlConstant";

// Endpoint real para refresh token
const REFRESH_TOKEN_ENDPOINT = URL.LOGIN_REFRESH_TOKEN;

/**
 * Solicita un nuevo accessToken usando el refreshToken.
 * @param {string} refreshToken
 * @returns {Promise<{ accessToken: string, refreshToken: string }>}
 */
export const refreshTokenService = async (refreshToken) => {
    const requestBody = { refreshToken };
    const response = await publicFetch.post(
        createUrl(REFRESH_TOKEN_ENDPOINT),
        JSON.stringify(requestBody),
        {
            headers: {
                "Content-Type": "application/json",
            },
        }
    );
    return response.data;
};
